<template>
  <div class="page">
    <div class="list-body">
      <form @submit.prevent="submitForm" class="row">
        <div class="col-md-12 d-flex flex-column gap-2">
          <div class="form-floating">
            <input type="text" v-model="formDate.token" class="form-control" id="balance" placeholder="Password "
                   required>
            <label for="password">Token</label>
          </div>
          <div class="form-floating">
            <input type="password" v-model="formDate.newPassword" class="form-control" id="balance" placeholder="Password "
                   required>
            <label for="password">New Password</label>
          </div>
          <div class="form-floating">
            <input type="password" v-model="password1" class="form-control" id="balance" placeholder="Password "
                   required>
            <label for="password">Confirm Password</label>
          </div>
        </div>
        <div class="container mt-4">
          <button type="submit" class="btn btn-primary w-100" >
            <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            SAVE
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password1: '',
      formDate:{
        newPassword: '',
        token: this.$route.query.token,
      },
      loading: false,
    }
  },
  methods: {
    resetForm(){
      this.formDate.newPassword = '';
      this.password1 = '';
      this.formDate.token = '';
    },
    async submitForm(){
      if(this.formDate.newPassword !== this.password1) {
        return Swal.fire({
          icon: "info",
          title: "Oops...",
          text: "The password was different",
        });
      }

      this.loading = true;
      return await this.$store.dispatch('confirmReset', this.formDate)
          .then(() => {
            responses.showSuccess('Password reset successfully');
            this.resetForm();
            this.$router.push('/');
          })
          .finally(() => this.loading = false);
    }
  }
}
</script>

<style scoped>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
}

.page {
  height: 100%;
  width: 100%;
  background: transparent;
  overflow-x: hidden;
  position: relative;
}

.list-body {
  padding: 10px;
  width: 100%;
  max-width: 600px;
  margin: 20px auto;
}

.col-md-4 {
  margin: 5px 0 0;
}
</style>

